import { KpiCard } from '@components/common';
import { Building2, Mail, Phone, UserRound } from 'lucide-react';
import React from 'react';

interface ClientsStatsCardsProps {
  totalClients: number;
  withEmail: number;
  withContact: number;
  withTin: number;
}

export const ClientsStatsCards: React.FC<ClientsStatsCardsProps> = ({
  totalClients,
  withEmail,
  withContact,
  withTin,
}) => (
  <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
    <KpiCard
      title="Total Clients"
      value={totalClients}
      icon={UserRound}
      accent="bg-pos-primary"
    />
    <KpiCard
      title="With Email"
      value={withEmail}
      sub="On this page"
      icon={Mail}
      accent="bg-pos-primary"
    />
    <KpiCard
      title="With Contact"
      value={withContact}
      sub="On this page"
      icon={Phone}
      accent="bg-pos-primary"
    />
    <KpiCard
      title="With TIN"
      value={withTin}
      sub="On this page"
      icon={Building2}
      accent="bg-pos-primary"
    />
  </div>
);
